import { styled } from '@styledComponents';
import { themeVariant, themeSpace, themeColor } from '@utils/styledTheme.util';
import { MediumTextStyles } from '@components/typography/interVariants';

export const StyleGPTInput = styled.textarea`
  padding: ${themeSpace(5)};
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 100%;
  ${themeVariant('featureHed20')};
  ${MediumTextStyles};
  letter-spacing: -0.0001em;

  :focus::placeholder {
    color: transparent;
  }
`;

export const CharCounter = styled.span`
  ${MediumTextStyles};
  color: rgba(118, 118, 118, 1);
  text-align: right;
  width: 100%;
  display: inline-block;
`;
